import { render, staticRenderFns } from "./AttachPlan.vue?vue&type=template&id=bffdeef0&scoped=true"
import script from "./AttachPlan.vue?vue&type=script&lang=js"
export * from "./AttachPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffdeef0",
  null
  
)

export default component.exports